export const MOCK_DATA = [
    {
        affiliations_name: '東京本社',
        card_name: '安全教育資料',
        expiry_date: '2025-12-31',
        image_id: 1,
        user_name: '山田 太郎'
    },
]

export const REGISTED_INFORMATION_STATUS_ALL = "すべて"

export const REGISTED_INFORMATION_STATUS = {
    needsConfirmation: "要確認",
    unnotified: "未通知",
    notSubmitted: "未提出",
    submitted: "提出済",
} as const

export type RegistedInformationStatus =
    typeof REGISTED_INFORMATION_STATUS[keyof typeof REGISTED_INFORMATION_STATUS]

export type RegistedInformationStatusFilter =
    | typeof REGISTED_INFORMATION_STATUS_ALL
    | RegistedInformationStatus

export const REGISTED_INFORMATION_STATUS_VALUES = Object.values(
    REGISTED_INFORMATION_STATUS
) as RegistedInformationStatus[]

export const REGISTED_INFORMATION_STATUS_FILTER_OPTIONS = [
    { label: REGISTED_INFORMATION_STATUS_ALL, value: REGISTED_INFORMATION_STATUS_ALL },
    ...REGISTED_INFORMATION_STATUS_VALUES.map((status) => ({
        label: status,
        value: status,
    })),
]

export const isRegistedInformationStatus = (
    status?: string | null
): status is RegistedInformationStatus =>
    REGISTED_INFORMATION_STATUS_VALUES.includes(status as RegistedInformationStatus)

export const normalizeRegistedInformationStatusFilter = (
    status?: string | null
): RegistedInformationStatusFilter =>
    isRegistedInformationStatus(status)
        ? status
        : REGISTED_INFORMATION_STATUS_ALL

const isRecord = (value: unknown): value is Record<string, unknown> =>
    Boolean(value) && typeof value === "object" && !Array.isArray(value)

const hasErrorValue = (value: unknown): boolean => {
    if (typeof value === "string") {
        return value.includes("__ERROR__")
    }
    if (Array.isArray(value)) {
        return value.some(hasErrorValue)
    }
    if (isRecord(value)) {
        return Object.values(value).some(hasErrorValue)
    }
    return false
}

export const hasRegistedInformationAnalysisError = (
    analysisResults?: unknown
): boolean => {
    if (!isRecord(analysisResults)) {
        return false
    }

    return Object.entries(analysisResults).some(([key, value]) => {
        if (!key.startsWith("analysis_m") || !isRecord(value)) {
            return false
        }
        return hasErrorValue(value["解析データ"])
    })
}

export const getRegistedInformationStatus = (item: {
    analysis_results?: unknown
    notification_flags?: boolean | null
    sent_flag?: boolean | null
}): RegistedInformationStatus => {
    if (hasRegistedInformationAnalysisError(item.analysis_results)) {
        return REGISTED_INFORMATION_STATUS.needsConfirmation
    }
    if (!item.notification_flags) {
        return REGISTED_INFORMATION_STATUS.unnotified
    }
    return item.sent_flag
        ? REGISTED_INFORMATION_STATUS.submitted
        : REGISTED_INFORMATION_STATUS.notSubmitted
}

export const getRegistedInformationStatusStyle = (status: string) => {
    switch (status) {
        case REGISTED_INFORMATION_STATUS.needsConfirmation:
            return "bg-red-200 text-red-800"
        case REGISTED_INFORMATION_STATUS.unnotified:
            return "bg-gray-200 text-gray-700"
        case REGISTED_INFORMATION_STATUS.notSubmitted:
            return "bg-yellow-200 text-yellow-800"
        case REGISTED_INFORMATION_STATUS.submitted:
            return "bg-green-200 text-green-800"
        default:
            return "bg-gray-200 text-gray-700"
    }
}
